import { Components, Inputs } from "@thisgorilla/primate-ds";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";

import { API_CALLS } from "../../../../../../../API/api_calls";
import { useAppSelector } from "../../../../../../../redux";
import { CommentList, PostCommentField } from "../../../../../../Common";
import { FlexColumn } from "../../../../../../Common/Styles";

const sortingOption = [
  { label: "Most Recent", value: "most_recent" },
  { label: "Most Relevant", value: "most_relevant" },
  { label: "Most Popular", value: "most_popular" },
];

const PostComments = ({
  post_id,
  isCommentShow,
  scrollAreaId,
}: {
  post_id: string;
  isCommentShow: boolean;
  scrollAreaId: string;
}) => {
  const contentRef = useRef(null);
  const [observeCount, setObserveCount] = useState(0);
  const [commentSorting, setCommentSortings] = useState(sortingOption[0]);
  const { allPostComments } = useAppSelector((state) => state.comments);
  const { comments, page, page_size, remaining_comments } =
    allPostComments?.[post_id];

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      setObserveCount((prev) => prev + 1);
    });

    if (contentRef.current) {
      observer.observe(contentRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [isCommentShow]);

  return (
    <>
      {(comments.length > 0 || isCommentShow || remaining_comments > 0) && (
        <FlexColumn $gapInPx={10} ref={contentRef}>
          {isCommentShow && (
            <PostCommentField
              parent_comment_id={null}
              post_id={post_id}
              scrollAreaId={scrollAreaId}
            />
          )}
          {(comments.length > 0 || remaining_comments > 0) && (
            <FlexColumn $gapInPx={0}>
              <CommentSorting>
                <Inputs.Search
                  fieldName="comment-sorting"
                  handleSelect={(option) => {
                    if (option.label === commentSorting.label) return;

                    setCommentSortings(option);
                    API_CALLS.COMMENTS.getCommentsForAPost(
                      {
                        post_id,
                        sort_by: option.value,
                        page: "1",
                        page_size: String(page_size),
                      },
                      true
                    );
                  }}
                  idPrefix="comment"
                  isRequired={false}
                  onChangeHandler={() => {}}
                  value={commentSorting.label}
                  size="Small"
                  options={sortingOption}
                  fieldType="Select"
                />
              </CommentSorting>
              <CommentList
                showReplyButton={true}
                comments={comments}
                observeCount={observeCount}
                scrollAreaId={scrollAreaId}
              />
              {remaining_comments > 0 && (
                <ButtonContainer>
                  <Components.Button
                    kind="Primary"
                    color="Neutral"
                    size="XS"
                    disabled={false}
                    label="Show more comments"
                    onClick={() => {
                      API_CALLS.COMMENTS.getCommentsForAPost(
                        {
                          post_id,
                          sort_by: commentSorting.value,
                          page: String(page + 1),
                          page_size: String(page_size),
                        },
                        page + 1 === 1
                      );
                    }}
                  />
                </ButtonContainer>
              )}
            </FlexColumn>
          )}
        </FlexColumn>
      )}
    </>
  );
};

export default PostComments;

const ButtonContainer = styled.div`
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem
    ${({ theme }) => theme.spacing["spacing-none"].value}rem;
`;

const CommentSorting = styled.div`
  width: min-content;
  min-width: 132px;

  & input {
    min-height: ${({ theme }) => theme.spacing["spacing-6"].value}rem;
    padding-top: ${({ theme }) => theme.spacing["spacing-05"].value}rem;
    padding-bottom: ${({ theme }) => theme.spacing["spacing-05"].value}rem;
    font-size: ${({ theme }) => theme.typography.Body.S["font-size"]}rem;
    line-height: ${({ theme }) => theme.typography.Body.S["line-height"]}rem;
  }

  & .icon-container {
    padding-top: ${({ theme }) => theme.spacing["spacing-05"].value}rem;
    padding-bottom: ${({ theme }) => theme.spacing["spacing-05"].value}rem;
    pointer-events: none;
  }

  & input {
    caret-color: transparent;
  }
`;
